import { ComponentType } from 'react';

const STORAGE_KEY = 'retry-lazy-refreshed';
const DefaultComponent = () => null;

/**
 * Function that retries lazy import and refreshes the page if an error occurs.
 * Implemented to mitigate the problem with Loading Chunk failed error.
 * @param componentImport Component import function.
 * @returns Component Promise.
 */
export const lazyRetry = async <Props extends object>(
  componentImport: () => Promise<{ default: ComponentType<Props> }>
) => {
  const hasRefreshed = JSON.parse(
    sessionStorage.getItem(STORAGE_KEY) || 'false'
  );

  try {
    const component = await componentImport();
    sessionStorage.setItem(STORAGE_KEY, 'false');

    return component;
  } catch (error) {
    if (hasRefreshed) throw error;

    sessionStorage.setItem(STORAGE_KEY, 'true');
    window.location.reload();

    return { default: DefaultComponent };
  }
};
